import { render, staticRenderFns } from "./OldUnionMenu.vue?vue&type=template&id=4681e96a&scoped=true"
import script from "./OldUnionMenu.vue?vue&type=script&lang=js"
export * from "./OldUnionMenu.vue?vue&type=script&lang=js"
import style0 from "./OldUnionMenu.vue?vue&type=style&index=0&id=4681e96a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681e96a",
  null
  
)

export default component.exports